

















import { defineComponent } from '@vue/composition-api';

export default defineComponent({
	props: {
		value: {
			type: Number,
			required: true,
		},
	},
	setup() {
		return {};
	},
});
